 <h2 mat-dialog-title class="dialog-header d-flex align-items-center justify-content-between">
    <span class="title">{{ "targets.txtDescription" | translate }} </span>
    <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 -960 960 960" width="20" fill="#1f1f1f" (click)="clickIconClose($event)">
        <path d="m291-240-51-51 189-189-189-189 51-51 189 189 189-189 51 51-189 189 189 189-51 51-189-189-189 189Z"/>
    </svg>
 </h2>
 <mat-dialog-content style="text-align: center;">
     <div class="block-icon d-flex justify-content-center align-items-center" >
        <span class="material-symbols-outlined">info</span>
     </div>
     <div class="block-descriptions" innerHtml="{{data.text}}"></div>
 </mat-dialog-content>
 <mat-dialog-actions align="center">
     <div class="btns-groups"> 
         <button class="btn-accept" (click)="onNoClick()">
             <span>{{ 'buttons.txtGotIt' | translate }}</span>
         </button>
     </div>       
   </mat-dialog-actions>
